import React, { useEffect, useState } from 'react';
import { Spin, Typography } from 'antd';
import Sdk from 'casdoor-js-sdk';
import sdkConfig from '../casdoorConfig';
import { PaymentAPI } from '../backend/api';

const { Text } = Typography;

const AuthCallbackPage = () => {
  const [message, setMessage] = useState('Authenticating...');
  const [error, setError] = useState(null);

  const processPendingPlan = async (userName) => {
    const pendingRaw = localStorage.getItem('pendingPlan');
    if (!pendingRaw) return false;

    const pendingPlan = JSON.parse(pendingRaw);
    localStorage.removeItem('pendingPlan');

    try {
      setMessage('Creating your order...');
      const orderRes = await PaymentAPI.createOrder(
        [{
          Name: pendingPlan.productName,
          Price: pendingPlan.price,
          Quantity: 1,
          PricingName: pendingPlan.pricingName,
          PlanName: pendingPlan.planName,
        }],
        userName
      );
      const order = orderRes?.data?.data;
      if (!order) throw new Error('Failed to create order');

      setMessage('Redirecting to payment...');
      const payRes = await PaymentAPI.getPaymentUrl(`${order.owner}/${order.name}`, 'provider_payment_paypal');
      const payUrl = payRes?.data?.data?.payUrl;
      if (!payUrl) throw new Error('Failed to get payment URL');

      window.location.href = payUrl;
      return true;
    } catch (err) {
      console.error('Pending plan processing error:', err);
      window.location.href = '/payment';
      return true;
    }
  };

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const sdk = new Sdk(sdkConfig);
        const accessToken = await sdk.exchangeForAccessToken();
        if (!accessToken) {
          setError('No access token received');
          return;
        }
        localStorage.setItem('casdoor_access_token', accessToken);
        const userInfo = await sdk.getUserInfo(accessToken);
        localStorage.setItem('casdoor_user', JSON.stringify(userInfo));

        const hasPending = await processPendingPlan(userInfo.name);
        if (!hasPending) {
          window.location.href = '/';
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err.message || 'Authentication failed');
      }
    };
    handleCallback();
  }, []);

  if (error) {
    return (
      <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <Text type="danger">Authentication failed: {error}</Text>
        <br />
        <a href="/">Go back</a>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '100px', padding: '50px' }}>
      <Spin size="large" />
      <div style={{ marginTop: '20px' }}>
        <Text>{message}</Text>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
